import { Box } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { StyledTypography } from '../styles/styles';

interface DeltaChange {
  from: unknown;
  to: unknown;
}

interface ActivityLogDeltaChangesProps {
  delta: Record<string, DeltaChange>;
  tone: keyof typeof Palette;
}

function formatFieldName(fieldName: string): string {
  return fieldName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
}

function formatValue(value: unknown): string {
  if (value === null || value === undefined) return 'null';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return value.toString();
  return JSON.stringify(value);
}

const ActivityLogDeltaChanges: React.FC<ActivityLogDeltaChangesProps> = ({ delta, tone }) => (
  <Box sx={{ p: 1 }}>
    <StyledTypography tone={tone} fontSize="0.75rem" sx={{ mb: 1, display: 'block', opacity: 0.7 }}>
      Changes:
    </StyledTypography>
    {Object.entries(delta).map(([fieldName, change]) => (
      <Box
        key={fieldName}
        sx={{
          mb: 1,
          p: 1,
          backgroundColor: Palette[tone].background,
          border: `1px solid ${Palette[tone].border}`,
          borderRadius: '4px',
        }}
      >
        <StyledTypography tone={tone} fontSize="0.75rem" fontWeight={600}>
          {formatFieldName(fieldName)}:
        </StyledTypography>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5, gap: 1 }}>
          <Box
            sx={{
              flex: 1,
              p: 0.5,
              backgroundColor: '#ffebee',
              border: '1px solid #f44336',
              borderRadius: '3px',
              textDecoration: 'line-through',
            }}
          >
            <StyledTypography tone={tone} fontSize="0.75rem" sx={{ color: '#d32f2f' }}>
              {formatValue(change.from)}
            </StyledTypography>
          </Box>
          <StyledTypography tone={tone} fontSize="0.75rem" sx={{ opacity: 0.7 }}>
            →
          </StyledTypography>
          <Box
            sx={{
              flex: 1,
              p: 0.5,
              backgroundColor: '#e8f5e8',
              border: '1px solid #4caf50',
              borderRadius: '3px',
            }}
          >
            <StyledTypography tone={tone} fontSize="0.75rem" sx={{ color: '#2e7d32' }}>
              {formatValue(change.to)}
            </StyledTypography>
          </Box>
        </Box>
      </Box>
    ))}
  </Box>
);

export default ActivityLogDeltaChanges;
